import React, { useCallback, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { VuiButton } from '../../../../../vodea/@vodea-ui/components/VuiButton';
import clsx from 'clsx';
import { Controller, useForm } from 'react-hook-form';
import NumberFormat from 'react-number-format';

interface Props {
  loading: boolean;
  handlePay: (payment: number) => void;
  disabled: boolean;
}

const ButtonSave: React.FC<Props> = ({ disabled, loading, handlePay}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    errors,
    reset,
    handleSubmit,
    control
  } = useForm({
    defaultValues: {
      payment: 0
    }
  })

  const handleOnClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onSubmit = handleSubmit((data) => {
    handlePay(data.payment);
    reset();
    handleOnClose();
  });

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  return (
    <>
      <Modal show={isOpen} onHide={handleOnClose} backdrop={'static'} centered>
        <Modal.Header closeButton>
          <Modal.Title>Payment</Modal.Title>
        </Modal.Header>

        <form className={'form-wrapper'} onSubmit={onSubmit}>
          <Modal.Body>
            <div
              className={clsx({
                'form-group': true,
                error: errors.payment
              })}
            >
              <label className={'form-label'}>Payment</label>
              <Controller
                name={'payment'}
                control={control}
                render={props => (
                  <NumberFormat
                    className='form-control'
                    value={props.value}
                    allowNegative={false}
                    thousandSeparator={'.'}
                    decimalSeparator={','}
                    decimalScale={0}
                    placeholder={'IDR 0'}
                    prefix={'IDR '}
                    onValueChange={({ value }) => props.onChange(value)}
                  />
                )}
              />
              <label className={'label-help'}>{errors.payment?.message}</label>
            </div>

          </Modal.Body>

          <Modal.Footer>
            <Button variant={'light'} onClick={handleOnClose}>
              Cancel
            </Button>
            <VuiButton forSubmit={true} label={'Save'} loading={loading} />
          </Modal.Footer>
        </form>
      </Modal>

      <VuiButton
        label="Save"
        loading={loading}
        onClick={handleOpen}
        customClass="btn-pay save"
        disabled={disabled}
      />
    </>
  );
}

export default ButtonSave;